import { EU_COMMON_ADDR_FORMAT_COUNTRIES, NA_COMMON_ADDR_FORMAT_COUNTRIES } from '~/utils/address'

type AddressData = {
  subdivision_name?: string
  country_code: string
  address_line_one: string
  address_line_two?: string
  address_line_three?: string
  city: string
  county?: string
  neighborhood?: string
  zip: string
}
const Address = ({ ...props }: AddressData) => {
  const { country_code } = props
  // Default
  let countrySpecificDetails = (
    <>
      <div>{props.address_line_three}</div>
      <div>{props.subdivision_name}</div>
      <div>{props.city}</div>
      <div>{props.county}</div>
      <div>{props.neighborhood}</div>
      <div>{props.zip}</div>
    </>
  )

  // Country region specific
  if (country_code === 'MEX') {
    countrySpecificDetails = (
      <>
        <div>{props.neighborhood}</div>
        <div>
          {props.zip} {props.city} {props.subdivision_name}
        </div>
      </>
    )
  } else if (EU_COMMON_ADDR_FORMAT_COUNTRIES.includes(country_code)) {
    countrySpecificDetails = (
      <div>
        {props.zip} {props.city}
      </div>
    )
  } else if (country_code === 'GBR') {
    countrySpecificDetails = (
      <>
        <div>{props.address_line_three}</div>
        <div>{props.city}</div>
        <div>{props.subdivision_name}</div>
        <div>{props.zip}</div>
      </>
    )
  } else if (country_code === 'IND') {
    countrySpecificDetails = (
      <>
        <div>{props.address_line_three}</div>
        <div>
          {props.city} {props.zip}
        </div>
      </>
    )
  } else if (country_code === 'BRA') {
    countrySpecificDetails = (
      <>
        <div>{props.neighborhood}</div>
        <div>
          {props.city} {props.subdivision_name}
        </div>
        <div>{props.zip}</div>
      </>
    )
  } else if (country_code === 'ISR') {
    countrySpecificDetails = (
      <>
        <div>{props.address_line_three}</div>
        <div>
          {props.zip} {props.city}
        </div>
      </>
    )
  } else if (NA_COMMON_ADDR_FORMAT_COUNTRIES.includes(country_code)) {
    countrySpecificDetails = (
      <div>
        {props.city} {props.subdivision_name} {props.zip}
      </div>
    )
  }

  return (
    <div>
      <div>{props.address_line_one}</div>
      <div>{props.address_line_two}</div>
      {countrySpecificDetails}
    </div>
  )
}

export default Address
